define(function (require, exports, module) {
    const init = function (app, _) {
        $.extend(app, {
            isStock: function () {
                return app.getParam('STOCK');
            },
        });
    };

    module.exports = init;

    return init;
});
